module.exports = __webpack_public_path__ + "static/media/md-flash-off.0f8afb64.svg";